import { Boundaries } from "@planzone/core";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State } from "./types";
import { resolveReplies } from "./resolveReplies";

function handleSuccess(
  state: State,
  {
    subject,
    discussion,
    page,
    size,
  }: Boundaries["retrieveDiscussion"]["success"],
): State {
  return state.map((result) => {
    if (result.subject !== subject) return result;

    const previousComments =
      page === 0
        ? []
        : result.discussion.comments.filter(
            (existing) =>
              !discussion.comments.some(
                (incoming) => incoming.uuid === existing.uuid,
              ),
          );

    return {
      ...result,
      discussion: {
        ...discussion,
        comments: resolveReplies([...previousComments, ...discussion.comments]),
      },
      page: page + 1,
      canLoadMore: discussion.comments.length >= size,
      request: setRequestStateToSuccess(),
    };
  });
}

export { handleSuccess };
